import { useState } from 'react';
import { v4 as uuid } from 'uuid';
import { ModalSelfieInstructions } from '~/components';
import { observer, useNavigate } from '~/modules';
import { Routes } from '~/routes';
import { DOC_TYPES, base64ToBlob, useStores } from '~/utils';
import OnboardingSelfie from './OnboardingSelfie';

const OnboardingSelfieContainer = () => {
  const navigate = useNavigate();
  const { user } = useStores();
  const [isModalOpen, setIsModalOpen] = useState(true);

  const handleSubmit = async (image: string) => {
    const blob = base64ToBlob(image);

    const picture = {
      uri: image,
      name: `${uuid()}.jpg`,
      mimeType: 'image/jpeg',
      type: DOC_TYPES.SELFIE,
      size: blob.size,
      blob: blob,
    };

    await user.userImageValidation(picture);
    await user.getTermsAndPolicy();
    navigate(Routes.ONBOARDING_DOC_PHOTO_FRONT);
  };
  return (
    <>
      <OnboardingSelfie handleSubmit={handleSubmit} />
      <ModalSelfieInstructions
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};

export default observer(OnboardingSelfieContainer);
